import { render } from "./forgot.vue?vue&type=template&id=7f84ff25&scoped=true"
import script from "./forgot.vue?vue&type=script&lang=js"
export * from "./forgot.vue?vue&type=script&lang=js"

import "./forgot.vue?vue&type=style&index=0&id=7f84ff25&scoped=true&lang=css"

import exportComponent from "C:\\Users\\28950\\source\\repos\\xtz\\hql\\bm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f84ff25"]])

export default __exports__